import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["input", "form", "imageUpload", "imagePreview", "imagePreviewContainer", "chatContainer"]

    connect() {
        this.handleKeyDown = this.handleKeyDown.bind(this)
        this.inputTarget.addEventListener('keydown', this.handleKeyDown)

        // Set up form submission handler
        this.formTarget.addEventListener('submit', this.handleSubmit.bind(this))

        // Scroll to bottom initially
        this.scrollToBottom()

        // Set up listeners for when content changes
        this.morphHandler = this.scrollToBottom.bind(this)
        document.addEventListener('turbo:morph', this.morphHandler)
        document.addEventListener('turbo:render', this.morphHandler)
    }

    disconnect() {
        this.inputTarget.removeEventListener('keydown', this.handleKeyDown)
        document.removeEventListener('turbo:morph', this.morphHandler)
        document.removeEventListener('turbo:render', this.morphHandler)
        this.formTarget.removeEventListener('submit', this.handleSubmit.bind(this))
    }

    scrollToBottom() {
        if (this.hasChatContainerTarget) {
            this.chatContainerTarget.scrollTop = this.chatContainerTarget.scrollHeight
        }
    }

    handleKeyDown(event) {
        if (event.key === 'Enter' && !event.shiftKey) {
            event.preventDefault()
            this.formTarget.requestSubmit()
        }
    }

    handleSubmit(event) {
        // Clear the form after submission
        setTimeout(() => {
            this.inputTarget.value = ''
            this.removeImage()
        }, 100)
    }

    fillSuggestion(event) {
        const message = event.currentTarget.innerText
        this.inputTarget.value = message
        this.inputTarget.focus()
    }

    previewImage() {
        const file = this.imageUploadTarget.files[0]
        if (file) {
            const reader = new FileReader()
            reader.onload = (e) => {
                this.imagePreviewTarget.src = e.target.result
                this.imagePreviewContainerTarget.style.display = 'inline-block'
            }
            reader.readAsDataURL(file)
        }
    }

    removeImage() {
        this.imageUploadTarget.value = ''
        this.imagePreviewContainerTarget.style.display = 'none'
    }
} 